import * as React from "react";
import { ReadOnlyFormGroup } from "components/common";
import SectionComponent from "components/common/Section/SectionComponent";
import EditLinkButton from "./EditLinkButton";
import { STEP_KEY as SERVER_CONFIG_KEY } from "../BackendWizard/ServerConfigStep";
const ServerConfigSection = ({ authenticationBackend }) => {
  const {
    title,
    description,
    config: { servers = [], systemUserDn, systemUserPassword, transportSecurity, verifyCertificates }
  } = authenticationBackend;
  const serverUrls = servers.map((server) => `${server.host}:${server.port}`).join(", ");
  return /* @__PURE__ */ React.createElement(
    SectionComponent,
    {
      title: "Server Configuration",
      headerActions: /* @__PURE__ */ React.createElement(EditLinkButton, { authenticationBackendId: authenticationBackend.id, stepKey: SERVER_CONFIG_KEY })
    },
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Title", value: title }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Description", value: description }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Server Address", value: serverUrls }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "System Username", value: systemUserDn }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "System Password", value: (systemUserPassword == null ? void 0 : systemUserPassword.isSet) ? "******" : null }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Transport Security", value: transportSecurity }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Verify Certificates", value: verifyCertificates })
  );
};
export default ServerConfigSection;
